import SiteFooter from "../components/SiteFooter";
import PublicPageHeader from "../components/PublicPageHeader";

const DisclaimerPage = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: "var(--secondary)" }}>
      <PublicPageHeader />
      <main className="px-6 py-12">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl border p-8 md:p-10" style={{ borderColor: "var(--border)" }}>
          <h1 className="text-4xl font-bold mb-6" style={{ fontFamily: "Fraunces, serif", color: "var(--primary)" }}>
            Disclaimer
          </h1>

          <div className="space-y-5 text-[15px] leading-7 opacity-90">
            <p>
              MoolTax provides a technology-enabled platform for tax filing support and related assistance.
              Information available on the platform is for general process guidance only.
            </p>
            <p>
              Users are solely responsible for the accuracy of the information and authenticity of the
              documents submitted by them.
            </p>
            <p>
              MoolTax shall not be liable for losses, penalties, or delays arising from incomplete,
              incorrect, misleading, or delayed information submitted by users, or from dependency on
              third-party systems and service providers.
            </p>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
};

export default DisclaimerPage;